// extracted by mini-css-extract-plugin
export default {"jap-button":"ArrowButton_jap-button__-SrZd","jap-btn-send":"ArrowButton_jap-btn-send__KrUx3"};